export default __webpack_public_path__ + "static/banner-space-b67266ceda3ddb7d18d4952196e589fc.jpg";